function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#adc6ca",
  fillRule: "evenodd",
  d: "M8 1a7 7 0 11-.001 14.001A7 7 0 018 1zm.339 5.42H6.984a.338.338 0 00-.339.338v.226a.34.34 0 00.339.339h.339v3.387h-.34a.338.338 0 00-.338.338v.226a.34.34 0 00.339.339h2.032a.34.34 0 00.339-.339v-.226a.338.338 0 00-.339-.338h-.339V6.758a.338.338 0 00-.338-.339zM8 3.934a.903.903 0 10.001 1.807A.903.903 0 008 3.934z"
});

function SvgStatusInfoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgStatusInfoinline;